export default __webpack_public_path__ + "static/media/Icons_Water_Fill_Grey Icon.29da100e.svg";